export type GetCallback = () => () => void
export type SetCallback = (newCallback: () => void) => void
export type UseCallback = (fallback: () => void) => void

/**
 * Helper for creating a callback to be consumed at a later date
 * Use in the app for navigation that does not need to be persisted or live in the data store
 */
export function createMutableCallback(): [GetCallback, SetCallback, UseCallback] {
    let callback: () => void

    function get() {
        return callback
    }

    function set(newCallback: () => void) {
        callback = newCallback
    }

    function use(fallback: () => void) {
        const callbackToUse = callback || fallback
        callback = null
        callbackToUse()
    }

    return [get, set, use]
}
